module.exports = __webpack_public_path__ + "static/img/Chinese.c92bf01e.png";